import styles from '@ui/components/Toggle/Toggle.module.scss';
import React from 'react';
import { Radio, RadioGroup } from '@ariakit/react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import FontAwesomeProIcon from '../FontAwesomeProIcon/FontAwesomeProIcon';

const Toggle = ({
  ariaLabel = null,
  ariaLabelledBy = null,
  firstLabel,
  firstIcon = null,
  id,
  secondLabel,
  secondIcon = null,
  size = 'regular',
  store,
}) => {
  const { value } = store.useState();

  return (
    <RadioGroup
      aria-label={ariaLabel}
      aria-labelledby={ariaLabelledBy}
      className={styles.switcher}
      store={store}
    >
      <label
        className={classNames(styles.switch, styles[size], {
          [styles.switchActive]: value === 1,
          [styles.withIcon]: !!firstIcon,
        })}
        htmlFor={`${id}-${firstLabel}`}
      >
        <Radio
          className={styles.switchRadio}
          id={`${id}-${firstLabel}`}
          value={1}
        />
        {!!firstIcon && <FontAwesomeProIcon icon={firstIcon} />}
        {firstLabel}
      </label>
      <label
        className={classNames(styles.switch, styles[size], {
          [styles.switchActive]: value === 2,
          [styles.withIcon]: !!secondIcon,
        })}
        htmlFor={`${id}-${secondLabel}`}
      >
        <Radio
          className={styles.switchRadio}
          id={`${id}-${secondLabel}`}
          value={2}
        />
        {!!secondIcon && <FontAwesomeProIcon icon={secondIcon} />}
        {secondLabel}
      </label>
    </RadioGroup>
  );
};

Toggle.propTypes = {
  ariaLabel: PropTypes.string,
  ariaLabelledBy: PropTypes.string,
  firstIcon: PropTypes.string,
  firstLabel: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  secondIcon: PropTypes.string,
  secondLabel: PropTypes.string.isRequired,
  size: PropTypes.oneOf(['small', 'regular']),
  /* eslint-disable react/forbid-prop-types */
  /** `useRadioStore()` return value from the `@ariakit/react` */
  store: PropTypes.object.isRequired,
};

export default Toggle;
